<script setup lang="ts">
import { CellState } from '@ui/components/calendar/picker/index'
import { getMonthName } from '@ui/utils/times'
import { eachMonthOfInterval, endOfMonth, isSameMonth } from 'date-fns'
import { isCalendarIntervalDisabled } from '../calendarAvailability'
import CalendarDate from './CalendarDate.vue'

const props = withDefaults(
  defineProps<{
    today?: Date
    disabledDate?: (date: Date) => boolean
  }>(),
  {
    today: () => new Date(),
  },
)

const model = defineModel<Date>({ default: () => new Date() })
const months = computed(() =>
  eachMonthOfInterval({
    start: new Date(model.value.getFullYear(), 0),
    end: new Date(model.value.getFullYear(), 11, 31),
  }),
)

function getState(date: Date) {
  if (isCalendarIntervalDisabled({ start: date, end: endOfMonth(date) }, props.disabledDate)) {
    return CellState.Disabled
  }
  return isSameMonth(model.value, date) ? CellState.Selected : CellState.Default
}
</script>

<template lang="pug">
.display-grid.grid-cols-3.row-gap-12.column-gap-8.p-t-24
  .flex-center-center.h-56(v-for="month of months" :key="month.getTime()")
    CalendarDate(
      :label="getMonthName(month)"
      :state="getState(month)"
      :today="isSameMonth(month, today)"
      @click="model = month"
    )
</template>
